import { getStepData } from "pages/application/question/questionSlice";
import { useSelector } from "react-redux";
import useDesktopChecker from "hooks/useDesktopChecker";
import useApplicationTabletChecker from "hooks/useApplicationTabletChecker";
import SectionBar from "components/v2/section-bar/SectionBar";

// The "Previous" control now lives in the bottom action row of each question as the Back button
// (see templates/shared/BackButton.tsx). The header only keeps the mobile section bar.
const PreviousQuestionButton = () => {
  const { section: activeSection, sections } = useSelector(getStepData);
  const isDesktop = useDesktopChecker();
  const isTablet = useApplicationTabletChecker();
  const isMobilePhone = !isDesktop && !isTablet;
  return (
    <header className="application-header">
      <div>{isMobilePhone && <SectionBar activeSection={activeSection} sections={sections} />}</div>
    </header>
  );
};

export default PreviousQuestionButton;
